import filters from './types'

import {ConditionFilters as Base} from './ConditionFilters'
import {useFilterStore} from './store'

const ConditionFilters = Object.assign(Base, {useFilterStore, filters})
export type {FilterProps, StoreProps, StoreInterface} from './store'
export {ConditionFilters}

